const Disclaimer = () => (
  <div className="py-2 bg-slate-50 border-b border-slate-100" data-testid="disclaimer-bar">
    <div className="container-shell text-xs text-slate-500 text-center">
      Trialeze provides procedural analytics based on structured information. It does not provide legal advice, does not assess character or ethics, and does not guarantee outcomes.
    </div>
  </div>
);

export default Disclaimer;
